export const sortByIndex = data => data?.sort((a, b) => a.index - b.index);
